var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "referral-rule-page" },
    [
      _c(
        "div",
        { staticClass: "hero" },
        [
          _vm._m(0),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.openCreate } },
            [_vm._v("新增规则")]
          ),
        ],
        1
      ),
      _c(
        "el-card",
        {
          attrs: { shadow: "never", "body-style": { padding: "0 20px 20px" } },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.list, size: "mini" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "rule.ruleNo",
                  label: "编号",
                  "min-width": "140",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "rule.title",
                  label: "标题",
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "rule.targetType", label: "对象", width: "120" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "rule.rewardAmount",
                  label: "奖励",
                  width: "100",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "rule.status", label: "状态", width: "90" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return _vm._l(row.actions, function (action) {
                        return _c(
                          "el-button",
                          {
                            key: action,
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.runAction(row, action)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.actionText(action)))]
                        )
                      })
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("REFERRAL RULE")]),
      _c("h2", [_vm._v("推荐规则")]),
      _c("p", [_vm._v("配置对象类型与奖励金额。")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }